import {HeadingBlock, SubheadingBlock, ParagraphBlock, QuoteBlock, BulletsBlock, CalloutBlock} from "./textBlocks";
import {ImageBlock, GalleryBlock, VideoBlock, AnimalBandBlock} from "./mediaBlocks";
import {ButtonBlock, InviteColleagueBlock} from "./actionBlocks";
import {CardsBlock, KeyFigureBlock, StepsBlock, FaqBlock} from "./cardBlocks";
import {NewsBlock, ThreadsBlock, AgentMoodBlock, SignupCounterBlock} from "./liveBlocks";
import {VisitorMoodBlock, AnimalDrawBlock} from "./funBlocks";

// Registre type de bloc -> composant ({data, ctx}). Les blocs « vivants » (actualités, fils, humeurs, compteur, tirage de
// pseudo) sont ajoutés par landing/blocks/liveBlocks.js et funBlocks.js. Un type absent de ce registre n'est pas rendu.
export const BLOCK_COMPONENTS = {
    heading: HeadingBlock,
    subheading: SubheadingBlock,
    paragraph: ParagraphBlock,
    quote: QuoteBlock,
    bullets: BulletsBlock,
    callout: CalloutBlock,
    image: ImageBlock,
    gallery: GalleryBlock,
    video: VideoBlock,
    animalBand: AnimalBandBlock,
    button: ButtonBlock,
    inviteColleague: InviteColleagueBlock,
    cards: CardsBlock,
    keyFigure: KeyFigureBlock,
    steps: StepsBlock,
    faq: FaqBlock,
    news: NewsBlock,
    threads: ThreadsBlock,
    agentMood: AgentMoodBlock,
    signupCounter: SignupCounterBlock,
    visitorMood: VisitorMoodBlock,
    animalDraw: AnimalDrawBlock,
};
